var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _circle, _path55, _path56, _path57;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIpopular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 377,
    viewBox: "0 0 377 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M187.417 283.621C138.2 271.296 168.481 214.57 110.45 200.042C52.4178 185.514 71.3537 121.85 133.385 137.439C195.416 152.947 244.551 113.525 282.341 158.824C314.091 196.859 277.526 306.148 187.417 283.621Z",
    fill: "#00C2A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.082 254.401C144.865 242.076 162.168 207.878 109.605 194.982C51.4917 180.78 69.5297 109.852 141.6 144.541C199.224 172.291 243.788 108.383 281.578 153.682C313.329 191.799 284.272 276.928 194.082 254.401Z",
    fill: "#00C2A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M282.341 301.396C218.351 301.396 278.505 229.407 218.923 229.407C173.624 229.407 169.951 270.299 112.98 270.299C77.0672 270.299 51.3569 196.759 110.123 196.759C168.89 196.759 147.179 149.664 203.088 149.664C273.771 149.664 240.879 197.575 295.564 197.575C349.678 197.575 347.882 301.396 282.341 301.396Z",
    fill: "#D916A8",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M282.26 301.377C227.167 301.377 306.991 213.228 239.491 215.023C165.788 216.982 169.869 270.28 112.899 270.28C76.9859 270.28 51.2756 196.74 110.042 196.74C220.066 196.74 161.707 149.646 203.007 149.646C273.69 149.646 240.797 197.557 295.483 197.557C349.597 197.557 347.801 301.377 282.26 301.377Z",
    fill: "#D916A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.456 263.241H77.4256C75.255 263.241 73.5037 261.49 73.5037 259.319V102.2C73.5037 100.03 75.255 98.2793 77.4256 98.2793H193.481C195.652 98.2793 197.403 100.03 197.403 102.2V259.319C197.403 261.49 195.627 263.241 193.456 263.241Z",
    fill: "white",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187.773 256.42H71.742C69.5714 256.42 67.8201 254.669 67.8201 252.499V95.3802C67.8201 93.21 69.5714 91.459 71.742 91.459H187.797C189.968 91.459 191.719 93.21 191.719 95.3802V252.499C191.719 254.669 189.943 256.42 187.773 256.42Z",
    fill: "white",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.953 248.961H64.9219C62.7513 248.961 61 247.21 61 245.04V87.9212C61 85.751 62.7513 84 64.9219 84H180.977C183.148 84 184.899 85.751 184.899 87.9212V245.04C184.899 247.21 183.123 248.961 180.953 248.961Z",
    fill: "white",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M171.234 100.942H74.6653V108.809H171.234V100.942Z",
    fill: "#FCCE14"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.944 213.334V179.054H74.6581V213.334H108.944Z",
    fill: "#FCCE14"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M147.184 113.199H98.0242V116.282H147.184V113.199Z",
    fill: "#FCCE14"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M171.234 131.572H87.8862V134.803H171.234V131.572Z",
    fill: "#F2F3F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.858 136.801H74.6653V140.031H115.858V136.801Z",
    fill: "#F2F3F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.937 147.232H74.6653V150.463H122.937V147.232Z",
    fill: "#F2F3F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M149.306 136.801H120.125V140.031H149.306V136.801Z",
    fill: "#F2F3F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171.209 136.801H152.537V140.031H171.209V136.801Z",
    fill: "#F2F3F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M171.209 142.029H162.379V145.259H171.209V142.029Z",
    fill: "#F2F3F5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4959 131.572H74.6653V134.803H83.4959V131.572Z",
    fill: "#F2F3F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M171.209 147.232H150.564V150.463H171.209V147.232Z",
    fill: "#F2F3F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M158.827 142.029H99.3562V145.259H158.827V142.029Z",
    fill: "#F2F3F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4971 142.029H74.6653V145.259H94.4971V142.029Z",
    fill: "#F2F3F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M146.839 147.232H127.007V150.463H146.839V147.232Z",
    fill: "#F2F3F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6435 156.388L157.991 156.388L157.991 153.158L74.6435 153.158L74.6435 156.388Z",
    fill: "#F2F3F5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M130.016 161.604L171.208 161.604L171.208 158.373L130.016 158.373L130.016 161.604Z",
    fill: "#F2F3F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M122.948 172.06L171.22 172.06L171.22 168.829L122.948 168.829L122.948 172.06Z",
    fill: "#F2F3F5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5765 161.604L125.757 161.604L125.757 158.373L96.5765 158.373L96.5765 161.604Z",
    fill: "#F2F3F5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6513 161.604L93.3237 161.604L93.3237 158.373L74.6513 158.373L74.6513 161.604Z",
    fill: "#F2F3F5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6579 166.844L83.4885 166.844L83.4885 163.613L74.6579 163.613L74.6579 166.844Z",
    fill: "#F2F3F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M162.388 156.388L171.219 156.388L171.219 153.158L162.388 153.158L162.388 156.388Z",
    fill: "#F2F3F5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6555 172.06L95.3013 172.06L95.3013 168.829L74.6555 168.829L74.6555 172.06Z",
    fill: "#F2F3F5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0398 166.844L146.51 166.844L146.51 163.613L87.0398 163.613L87.0398 166.844Z",
    fill: "#F2F3F5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M151.391 166.844L171.223 166.844L171.223 163.613L151.391 163.613L151.391 166.844Z",
    fill: "#F2F3F5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0225 172.06L118.854 172.06L118.854 168.829L99.0225 168.829L99.0225 172.06Z",
    fill: "#F2F3F5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6435 223.172L157.991 223.172L157.991 219.941L74.6435 219.941L74.6435 223.172Z",
    fill: "#F2F3F5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M130.016 228.412L171.208 228.412L171.208 225.181L130.016 225.181L130.016 228.412Z",
    fill: "#F2F3F5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M122.948 238.843L171.22 238.843L171.22 235.613L122.948 235.613L122.948 238.843Z",
    fill: "#F2F3F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5765 228.412L125.757 228.412L125.757 225.181L96.5765 225.181L96.5765 228.412Z",
    fill: "#F2F3F5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6513 228.412L93.3237 228.412L93.3237 225.181L74.6513 225.181L74.6513 228.412Z",
    fill: "#F2F3F5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6579 233.627L83.4885 233.627L83.4885 230.397L74.6579 230.397L74.6579 233.627Z",
    fill: "#F2F3F5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M162.388 223.172L171.219 223.172L171.219 219.941L162.388 219.941L162.388 223.172Z",
    fill: "#F2F3F5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6555 238.843L95.3013 238.843L95.3013 235.613L74.6555 235.613L74.6555 238.843Z",
    fill: "#F2F3F5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0398 233.627L146.51 233.627L146.51 230.397L87.0398 230.397L87.0398 233.627Z",
    fill: "#F2F3F5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M151.391 233.627L171.223 233.627L171.223 230.397L151.391 230.397L151.391 233.627Z",
    fill: "#F2F3F5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0225 238.843L118.854 238.843L118.854 235.613L99.0225 235.613L99.0225 238.843Z",
    fill: "#F2F3F5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M162.848 187.85H119.78V189.946H162.848V187.85Z",
    fill: "#1071E5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M116.45 190.045C117.077 190.045 117.585 189.537 117.585 188.91C117.585 188.284 117.077 187.776 116.45 187.776C115.823 187.776 115.315 188.284 115.315 188.91C115.315 189.537 115.823 190.045 116.45 190.045Z",
    fill: "#1071E5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M156.311 193.004H119.78V195.1H156.311V193.004Z",
    fill: "#1071E5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M116.45 195.199C117.077 195.199 117.585 194.691 117.585 194.065C117.585 193.438 117.077 192.93 116.45 192.93C115.823 192.93 115.315 193.438 115.315 194.065C115.315 194.691 115.823 195.199 116.45 195.199Z",
    fill: "#1071E5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M151.871 198.183H119.78V200.279H151.871V198.183Z",
    fill: "#1071E5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M116.45 200.353C117.077 200.353 117.585 199.845 117.585 199.219C117.585 198.592 117.077 198.084 116.45 198.084C115.823 198.084 115.315 198.592 115.315 199.219C115.315 199.845 115.823 200.353 116.45 200.353Z",
    fill: "#1071E5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M159.567 203.337H119.78V205.434H159.567V203.337Z",
    fill: "#1071E5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M116.45 205.507C117.077 205.507 117.585 204.999 117.585 204.373C117.585 203.746 117.077 203.239 116.45 203.239C115.823 203.239 115.315 203.746 115.315 204.373C115.315 204.999 115.823 205.507 116.45 205.507Z",
    fill: "#1071E5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M112.133 123.311H133.741",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M112.133 94.1111H133.741",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M171.209 179.046V213.325",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180.949,
    cy: 90.9494,
    r: 25.9494,
    fill: "#00C2A8",
    stroke: "white",
    strokeWidth: 4
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M187.667 76H194.333V106H187.667V76Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M177.667 82.6667H184.333V106H177.667V82.6667Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M174.333 91H167.667V106H174.333V91Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpopular);
export default __webpack_public_path__ + "static/media/ipopular.4f559fe316563428f18e38ac62d4cbf7.svg";
export { ForwardRef as ReactComponent };